import { FC } from 'react';
import { DashboardCardProps } from '../../types/types';

const DashboardCard: FC<DashboardCardProps> = ({ title, value, status }) => {
  const getStatusColor = (status?: string) => {
    if (!status) return '';
    
    switch (status) {
      case 'success':
      case 'Active':
      case 'Operational':
        return 'bg-green-100 text-green-800';
      case 'warning':
      case 'Attention':
        return 'bg-yellow-100 text-yellow-800';
      case 'error':
      case 'Error':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-blue-100 text-blue-800';
    }
  };

  const getStatusText = (status?: string) => {
    if (!status) return '';
    
    switch (status) {
      case 'success':
        return 'Active';
      case 'warning':
        return 'Attention';
      case 'error':
        return 'Error';
      default:
        return status;
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-sm font-medium text-gray-500">{title}</h3>
        {status && (
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(status)}`}>
            {getStatusText(status)}
          </span>
        )}
      </div>
      <p className="text-2xl font-semibold text-gray-800">{value}</p>
    </div>
  );
};

export default DashboardCard;